import type { UserMedia, Character } from '../types';
import type { MediaList, Character as AniCharacter } from '../types/anilist';

export const mapUserMedia = (mediaList: MediaList): UserMedia => {
    return {
        id: mediaList.media.id,
        title: {
            english: mediaList.media.title.english,
            romaji: mediaList.media.title.romaji
        },
        coverImage: {
            medium: mediaList.media.coverImage.medium,
            large: mediaList.media.coverImage.large
        },
        bannerImage: mediaList.media.bannerImage,
        description: mediaList.media.description,
        averageScore: mediaList.media.averageScore,
        popularity: mediaList.media.popularity,
        episodes: mediaList.media.episodes,
        genres: mediaList.media.genres,

        userStatus: mediaList.status,
        userScore: mediaList.score,
        userProgress: mediaList.progress,
        userRepeat: mediaList.repeat,

        characters: mediaList.media.characters.edges.map(mapCharacter)
    };
};

export const mapCharacter = (character: AniCharacter): Character => {
    const voiceActor = character.voiceActors && (character.voiceActors?.length ?? 0) > 0 ? {
        id: character.voiceActors[0].id,
        name: character.voiceActors[0].name.full,
        imageUrl: character.voiceActors[0].image?.medium
    } : null;

    return {
        id: character.node.id,
        name: character.node.name.full,
        imageUrl: character.node.image?.medium,
        role: character.role,
        voiceActor
    }
};
